import React from 'react';
import { useIntl } from 'react-intl';
import { Heading, PropertyGroup } from '../../components';
import { listingFieldSearchParam } from '../../util/search';

import css from './ListingPage.module.css';

const SectionMultiEnumMaybe = props => {
  const {
    heading,
    options,
    selectedOptions,
    showUnselectedOptions = true,
    fieldKey,
    scope,
    filterConfig,
  } = props;
  const intl = useIntl();
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  const idSlug = heading.toLowerCase().replace(/ /g, '_');

  // Returns null for fields that aren't search filters, which is what stops
  // PropertyGroup linking them.
  const getLinkForOption = (optionKey, optionLabel) => {
    const search = listingFieldSearchParam(fieldKey, optionKey, { scope, filterConfig });
    return search
      ? {
          search,
          ariaLabel: intl.formatMessage(
            { id: 'ListingPage.showAllInOption' },
            { option: optionLabel }
          ),
        }
      : null;
  };

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <PropertyGroup
        id={`ListingPage.${idSlug}`}
        ariaLabel={heading}
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
        getLinkForOption={getLinkForOption}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
